import { Badge, colors } from "@minuthq/meatball-ui-react"

import { ReportCard } from "src/components/Reports/ReportCard"
import { useTranslate } from "src/i18n/useTranslate"
import { ReportRoutes } from "src/router/reportRoutes"
import MinutAIIcon from "src/ui/icons/minut-ai.svg"

export function AiAssistantAnalyticsReportCard() {
  const { t, langKeys, tPlaceholder } = useTranslate()

  const titleComponents = [
    <div key={"new-badge"}>
      <Badge color="promotional">{t(langKeys.new_badge_title)}</Badge>
    </div>,
  ]

  return (
    <ReportCard
      icon={<MinutAIIcon width={24} height={24} color={colors.textPrimary} />}
      titleComponents={titleComponents}
      title={tPlaceholder("AI Assistant analytics")}
      description={tPlaceholder(
        "See how the AI assistant is performing across your portfolio. You can track total conversations, how many were resolved automatically, escalated to your team, or left unresolved."
      )}
      linkTo={ReportRoutes.AiAssistantAnalytics.location().pathname}
    />
  )
}
